import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getRmvendorquotationStruct, setData} from './RmvendorquotationStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './RmvendorquotationAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateRmvendorquotationObj,addRmvendorquotationObj, setShowEditForRmvendorquotation} from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';



export default function RmvendorquotationEditFormImpl(){
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getRmvendorquotationStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {rmvendorquotationDashboard} = useSelector((state)=>state.pharmaslice);
    const [rmvendorquotationId, setRmvendorquotationId] = useState(rmvendorquotationDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);

    const {rawdemandObj} = useSelector((state) => state.pharmaslice.rawdemandDashboard);
        
    const {rmvendorList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForrmvendorid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'rmvendorname', e.target.value==0?'Select Item':rmvendorList.find(obj => obj.id === e.target.value).title);
    }

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (rmvendorquotationId!==-1) {
            if (dataLoaded) return;
            getAPI(rmvendorquotationId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['rawdemandid']: {
                ...formValues['rawdemandid'],
                value: rawdemandObj.id
            }
        })
    },[]);

    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues,e);
    }

    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addRmvendorquotationObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForRmvendorquotation(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateRmvendorquotationObj(obj));
        setNotification('Record with id['+rmvendorquotationId+'] has been updated successfully !!!');
        dispatch(setShowEditForRmvendorquotation(false));
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,rmvendorquotationId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, createAPI, updateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:440}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>Vendor Quotation {rmvendorquotationId===-1?'Add':'Edit'}</Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.rawdemandid.placeholder}
                                    required={formValues.rawdemandid.required}
                                    label={formValues.rawdemandid.label}
                                    name={formValues.rawdemandid.name}
                                    value={formValues.rawdemandid.value}
                                    onChange={handleTextChange}
                                    error={formValues.rawdemandid.error}
                                    helpertext={formValues.rawdemandid.error && formValues.rawdemandid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                            
                            <Grid item lg={8} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.rmvendorid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.rmvendorid.label}
                                            name={formValues.rmvendorid.name}
                                            value={formValues.rmvendorid.value}
                                            onChange={handleDynamicSelectedValueForrmvendorid}
                                            
                                            error={formValues.rmvendorid.error}
                                            helpertext={formValues.rmvendorid.error && formValues.rmvendorid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                rmvendorList && rmvendorList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>   
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.quotation.placeholder}
                                    required={formValues.quotation.required}
                                    label={formValues.quotation.label}
                                    name={formValues.quotation.name}
                                    value={formValues.quotation.value}
                                    onChange={handleTextChange}
                                    error={formValues.quotation.error}
                                    helpertext={formValues.quotation.error && formValues.quotation.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>                     
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.rmvendorname.placeholder}
                                    required={formValues.rmvendorname.required}
                                    label={formValues.rmvendorname.label}
                                    name={formValues.rmvendorname.name}
                                    value={formValues.rmvendorname.value}
                                    onChange={handleTextChange}
                                    error={formValues.rmvendorname.error}
                                    helpertext={formValues.rmvendorname.error && formValues.rmvendorname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', display:'none' }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{rmvendorquotationId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForRmvendorquotation(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};